import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import {
    MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatStepper } from '@angular/material/stepper';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, firstValueFrom, merge, Observable, of, Subscription, switchMap } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    first,
    map, pairwise,
    shareReplay, startWith, take, tap, withLatestFrom,
} from 'rxjs/operators';
import { SelectResourceComponent } from 'src/app/resource-dispo/components/select-resource/select-resource.component';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import { CommissionTypeNameEnum, CommissionWizardSteps } from '../../../dave-data-module/entities/commissionType.entity';
import { State } from '../../../dave-data-module/State';
import {
    getCommissionById,
} from '../../../dave-data-module/State/selectors/commission.selector';
import {
    getCommissionTypeById,
    getCommissionTypeDictionary,
    getCommissionTypes,
} from '../../../dave-data-module/State/selectors/commissionType.selectors';
import {
    getUserToCommissionByCommissionId,
    getUserToCommissions,
} from '../../../dave-data-module/State/selectors/user-to-commission.selector';
import {
    hasRequiredField,
    IDetailListTemplateData,
    IDetailListTemplateDataProperty,
} from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { Address, appMatDialogDefaultConfig, isNotNullOrUndefined, SearchQueriesDebounceTime } from '../../../helper/helper';
import {
    ICommissionDetailListTemplateEntrys,
    ICommissionForm,
    IParentCommissionSelectOption,
} from '../detail-commission/helper';

import { Color, MAT_COLOR_FORMATS, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { Actions, ofType } from '@ngrx/effects';
import moment, { Moment } from 'moment';
import { PartnerSpecificationType, PartnerTypeEnum } from 'src/app/dave-data-module/entities/partner.entity';
import {
    getPartner,
    getPartnerOfficeDictionary,
    getPartnerOfficesFetched,
} from 'src/app/dave-data-module/State/selectors/partners.selectors';
import { ActivityEntity } from '../../../dave-data-module/entities/activity.entity';
import { JobSpecificationEntity } from '../../../dave-data-module/entities/job-specification.entity';
import { EmployeeResourceScheduleEntity } from '../../../dave-data-module/entities/resource-dispo/employee-resource-schedule.entity';
import { ActivityResolver } from '../../../dave-data-module/guards/activity.resolver';
import { EmployeeResourceScheduleResolver } from '../../../dave-data-module/guards/resource-dispo/employee-resource-scheduler.resolver';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { ActivityActions } from '../../../dave-data-module/State/actions/activity.actions';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { EmployeeResourceScheduleActionTypes } from '../../../dave-data-module/State/actions/resource-dispo/employee-resource-schedule.actions';
import { getActivities, getActivitiesActive, getActivityDictionary, getActivityFetched } from '../../../dave-data-module/State/selectors/activity.selector';
import { getJobSpecification, getJobSpecificationDictionary } from '../../../dave-data-module/State/selectors/job-specification.selector';
import { getEmployeeResourceSchedules, getEmployeeResourceSchedulesFetched } from '../../../dave-data-module/State/selectors/resource-dispo/employee-resource-schedule.selectors';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { BreakpointObserverService } from '../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import { SelectSearchData } from '../../../dave-utils-module/select-search/components/select-search-legacy/select-search-legacy.component';
import { getErrorMessage } from '../../../helper/validation.helper';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { getOfficeByCustomerId, getOfficesFetched } from '../../../dave-data-module/State/selectors/offices.selectors';
import { OfficeResolver } from '../../../dave-data-module/guards/office.resolver';
import {CommissionMeta} from '../../../helper/page-metadata';
import { getStatusFromBackoffice } from '../../../dave-data-module/State/selectors/statusFromBackoffice.selectors';
import { StatusFromBackofficeNames } from '../../../dave-data-module/entities/statusFromBackoffice.entity';
import { CommissionActionTypes } from '../../../dave-data-module/State/actions/commission.actions';
import { LoadingService } from '../../../services/loading.service';
import {
    getEmployees,
    getEmployeesSortedByNameStartWithMe, getUserByEmployeeId,
} from '../../../dave-data-module/State/selectors/employees.selectors';
import {
    SelectSearchOption
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { CommentEntityTypeEnum } from '../../../dave-data-module/entities/comment.entity';
import { getUser } from '../../../dave-data-module/State/selectors/users.selectors';
import { FileUploadParams, fileUploadParamsObj } from '../../../dave-data-module/State/actions/files.actions';
import { FolderTypes, getFolderTypeString } from '../../../dave-data-module/entities/folder.entity';
import { ViewStyleConfig } from '../../../dave-data-module/entities/viewStyleSetting.entity';
import {
    PersonModalComponent,
    PersonModalComponentDialogData,
} from '../../../dave-person-module/components/person-modal/person-modal';
import { DepartmentEntity } from '../../../dave-data-module/entities/department.entity';
import {
    getDepartmentById,
    getDepartmentFetched,
    getDepartmentsActive,
} from '../../../dave-data-module/State/selectors/department.selector';
import { DepartmentResolver } from '../../../dave-data-module/guards/department.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { getPersons } from '../../../dave-data-module/State/selectors/person.selectors';
import {
    FILTER_TYPE_SEARCH_MULTI_SELECT,
    FilterOption, IFilterTypeSearchMultiSelectValue,
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { FilterTypes } from '../../../services/default-filter.service';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { getEntityRole } from '../../../dave-data-module/State/selectors/entity-role.selector';
import { UserToCommissionActionTypes } from '../../../dave-data-module/State/actions/user-to-commission.action';
import { Person2EntityActionTypes } from '../../../dave-data-module/State/actions/person2entity.action';
import { Person2EntityEntityTypeEnum } from '../../../dave-data-module/entities/person2entity.entity';
import {
    getPerson2EntityByCommissionId,
} from '../../../dave-data-module/State/selectors/person2entity.selectors';
import { getPersonTypes } from '../../../dave-data-module/State/selectors/personType.selectors';
import { PENDING_CHANGES_DEFAULT_MESSAGE } from '../../../dave-data-module/guards/pending-changes.guard';
import {
    NewCommissionDialogComponent, NewCommissionDialogComponentDialogData,
} from '../../../new-commission-dialog/new-commission-dialog.component';
import {
    KaplStatus4DialogComponent,
    MissingCommissionValuesDialogData, MissingCommissionValuesResult,
} from '../kapl-status4-dialog/kapl-status4-dialog.component';
import { CustomizationDataService } from '../../../dave-data-module/services/customization-data.service';
import { CustomerDataService } from '../../../dave-data-module/services/customer-data.service';
import {
    getMySharepointToken
} from '../../../dave-file-explorer/components/file-explorer/sharepoint/sharepoint-helper';
import { OAuthTokenActionTypes } from '../../../dave-data-module/State/actions/o-auth-token.actions';
import { getOAuthTokenFetched } from '../../../dave-data-module/State/selectors/o-auth-token.selector';
import { UserToCommissionResolver } from '../../../dave-data-module/guards/user-to-commission.resolver';
import { CommissionWizardDialogService } from '../../../services/commission-wizard-dialog.service';
import { ActivatedRoute } from '@angular/router';
export interface CommissionWizardComponentDialogData {
    commissionId: number;
    detailListTemplateEntries: ICommissionDetailListTemplateEntrys;
    statusBackofficeForm: ICommissionForm['StatusBackofficeId'];
    partnerOfficeForm: ICommissionForm['PartnerOffice'];
    wizardSteps?: CommissionWizardSteps[];
}

type WizardStep = {
    controls?: FormArray;
    customSave?: () => void;
    customTemplate?: TemplateRef<any>;
    data?: Observable<IDetailListTemplateData>;
    name: string;
};

export interface EmployeePerson {
    EntityType: "Employee" | "Person" | null;
    Id: number | null;
}

@Component({
    selector: 'app-commission-wizard',
    templateUrl: './commission-wizard.component.html',
    styleUrls: ['./commission-wizard.component.scss'],
    providers: [CurrencyPipe, DecimalPipe, DatePipe, { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS }],
})
export class CommissionWizardComponent implements OnInit, OnDestroy, AfterViewInit {
    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minHeight: '75vh',
        minWidth: '75vw',
        disableClose: true
    }
    @ViewChild('selectTeamTemplate') private selectTeamTemplate: TemplateRef<any>;
    @ViewChild('capacityTemplate') private capacityTemplate: TemplateRef<any>;
    @ViewChild('resourceTemplate') private resourceTemplate: TemplateRef<any>;
    @ViewChild('addressTemplate') private addressTemplate: TemplateRef<any>;
    @ViewChild('pageOne') private stepOneTemplate: TemplateRef<any>;
    @ViewChild('selectResourceComponent') private SelectResourceComponent: SelectResourceComponent;
    @ViewChild('Stepper') public Stepper: MatStepper;
    @ViewChild('stepOneTemplateKapl') private stepOneTemplateKapl: TemplateRef<any>;
    @ViewChild('stepTwoTemplateKapl') private stepTwoTemplateKapl: TemplateRef<any>;
    @ViewChild('parentCommissionSearchTemplate') private parentCommissionSearchTemplate: TemplateRef<any>;



    @Input()
    set CommissionId(id: number) {
        this.CommissionId$.next(id);
    }
    get CommissionId() {
        return this.CommissionId$.value;
    }

    protected parentCommissionOptionSearchFunction = (searchQuery: string, option: SelectSearchOption ) => {
        return option.optionLabel.toLowerCase().includes(searchQuery);
    }
    private _DetailListTemplateEntrys: ICommissionDetailListTemplateEntrys;
    private _detailListTemplateEntrys: ICommissionDetailListTemplateEntrys;
    protected kaplParentIdSet$ = new BehaviorSubject<boolean>(false);
    @Input() set DetailListTemplateEntrys(v: ICommissionDetailListTemplateEntrys) {
        // override
        this._detailListTemplateEntrys = v;
        this.parentCommissionOptionSearchFunction = v.ParentCommission.options.specialInput.singleSelectSearch.searchFunction;
        this._DetailListTemplateEntrys = this.overrideDetailListTemplateEntrys(v);

            const locationControl =
                v.Location?.options?.specialInput?.location?.formGroup as FormControl<Address>;
            if (locationControl) {
                firstValueFrom(this.store.select(getPartner)).then(p => {
                    const defaultCountry = p?.AdditionalData?.defaultCountry;
                    if (
                        defaultCountry &&
                        locationControl.pristine &&
                        !locationControl.value?.Country
                    ) {
                        locationControl.setValue({
                            ...locationControl.value,
                            Country: defaultCountry,
                        });
                    }
                });
            }


        if (v.ParentCommission && v.Customer && v.Description) {
            this.parentCommissionOptionsSorted$ = merge(
                v.Customer.formControl.valueChanges,
                v.Description.formControl.valueChanges,
                v.ParentCommission.formControl.valueChanges
            ).pipe(
                debounceTime(SearchQueriesDebounceTime),
                startWith(null),
                map(() => {
                    const searchQuery = v.Description.formControl.value?.trim().toLowerCase() || '';
                    if (!searchQuery) {
                        this.parentCommissionOptionsFilterResultCount$.next(0);
                        return v.ParentCommission.options.specialInput.singleSelectSearch.options;
                    }
                    const options: IParentCommissionSelectOption[] = v.ParentCommission.options.specialInput.singleSelectSearch.options;
                    const customerId = this.DetailListTemplateEntrys.Customer.formControl.value?.Id;
                    let filterByCustomerId = false;
                    if (customerId) {
                       filterByCustomerId = options.some(o =>  o.customerId === customerId && !!o?.descriptionSearch?.includes(searchQuery));
                    }
                    let count = 0;

                    const ret: Array<IParentCommissionSelectOption&{ isSearchResult?: boolean}> = options.map<IParentCommissionSelectOption&{ isSearchResult?: boolean}>(o => {
                        const isSearchResult = (!filterByCustomerId || o.customerId === customerId) && !!o?.descriptionSearch?.includes(searchQuery);
                        if (isSearchResult) {
                            count++;
                        }
                        return {...o, isSearchResult }
                    });
                    this.parentCommissionOptionsFilterResultCount$.next(count);
                    return ret.sort((a,b) => !!a.isSearchResult === !!b.isSearchResult ? 0 : !!a.isSearchResult ? -1 : 1);
                }),
                shareReplay({refCount: true, bufferSize: 1}),
            );
        }
    }
    get DetailListTemplateEntrys() {
        return this._DetailListTemplateEntrys;
    }
    @Output() Save = new EventEmitter<{wizardPage: number | null, routerLink: any[], skipValidation?: boolean }>();
    @Input() StatusBackofficeForm: ICommissionForm['StatusBackofficeId'];
    @Input() PartnerOfficeForm: ICommissionForm['PartnerOffice'];
    @Input() WizardSteps: CommissionWizardSteps[];

    get IsNewCommission(): boolean {
        return this.DialogData != null && this.DialogData.commissionId == null;
    }
    employeeFilterValues$ = new BehaviorSubject<{
        [FilterTypes.JobSpecificationIds]: IFilterTypeSearchMultiSelectValue<number>[];
        [FilterTypes.Roles]: IFilterTypeSearchMultiSelectValue<number>[];
    }>({
        [FilterTypes.JobSpecificationIds]: [],
        [FilterTypes.Roles]: [],
    });
    employeeFilterValuesAgent$ = new BehaviorSubject<{
        [FilterTypes.JobSpecificationIds]: IFilterTypeSearchMultiSelectValue<number>[];
        [FilterTypes.Roles]: IFilterTypeSearchMultiSelectValue<number>[];
    }>({
        [FilterTypes.JobSpecificationIds]: [],
        [FilterTypes.Roles]: [],
    });

    personFilterValues$ = new BehaviorSubject<{
        [FilterTypes.Roles]: IFilterTypeSearchMultiSelectValue<number>[];
    }>({
        [FilterTypes.Roles]: [],
    });

    singleEmployeeFilterValues$ = new BehaviorSubject<{
        [FilterTypes.JobSpecificationIds]: IFilterTypeSearchMultiSelectValue<number>[];
    }>({
        [FilterTypes.JobSpecificationIds]: [],
    });
    private employeesWithUserId$ = this.store.select(getEmployees).pipe(
        map((employees) =>
            employees.filter(e=> e!!.UserId)
        )
    );

    protected employeePersonOptions$ = combineLatest([
        this.employeesWithUserId$,
        this.store.select(getPersons),
        this.employeeFilterValues$,
        this.store.select(getPersonTypes),
        this.store.select(getJobSpecification)
    ]).pipe(
        map(([employees, persons, filterValues, pTypes, jobSpecs]) => {
            const jobSpecIds = filterValues[FilterTypes.JobSpecificationIds]?.map(v => v.id) ?? [];
            const roleIds = filterValues[FilterTypes.Roles]?.map(v => v.id) ?? [];

            const mappedEmployees = (employees ?? []).map(e => ({
                Id: e.Id,
                EntityType: 'Employee' as const,
                optionLabel: [
                    e.DisplayName,
                    jobSpecs.find(
                        js => js.Id === e.JobSpecificationId
                    )?.Name,
                    e.Email,
                ]
                    .filter(v => !!v)
                    .join(' | '),
                JobSpecificationId: e.JobSpecificationId,
                PersonTypeId: null as number | null,
            }));
            const mappedPersons = (persons ?? []).map(p => ({
                Id: p.Id,
                EntityType: 'Person' as const,
                optionLabel: [
                    p.DisplayName,
                    pTypes.find(
                        pt => pt.Id === p.PersonTypeId
                    )?.Name,
                    p.Email,
                    p.Organisation,
                ]
                    .filter(v => !!v)
                    .join(' | '),
                JobSpecificationId: null as number | null,
                PersonTypeId: p.PersonTypeId,
            }));

            const combined = [...mappedEmployees, ...mappedPersons];

            return combined.filter(e => {
                const jobSpecMatch = !jobSpecIds.length || (e.EntityType === 'Employee' && jobSpecIds.includes(e.JobSpecificationId));
                const roleMatch = !roleIds.length || (e.EntityType === 'Person' && roleIds.includes(e.PersonTypeId));
                if (jobSpecIds.length && roleIds.length) return jobSpecMatch || roleMatch;
                if (jobSpecIds.length) return e.EntityType === 'Employee' && jobSpecMatch;
                if (roleIds.length) return e.EntityType === 'Person' && roleMatch;
                return true;
            });
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    protected employeePersonOptionsAgent$ = combineLatest([
        this.employeesWithUserId$,
        this.store.select(getPersons),
        this.employeeFilterValuesAgent$,
        this.store.select(getPersonTypes),
        this.store.select(getJobSpecification)
    ]).pipe(
        map(([employees, persons, filterValues, pTypes, jobSpecs]) => {
            const jobSpecIds = filterValues[FilterTypes.JobSpecificationIds]?.map(v => v.id) ?? [];
            const roleIds = filterValues[FilterTypes.Roles]?.map(v => v.id) ?? [];

            const mappedEmployees = (employees ?? []).map(e => ({
                Id: e.Id,
                EntityType: 'Employee' as const,
                optionLabel: [
                    e.DisplayName,
                    jobSpecs.find(
                        js => js.Id === e.JobSpecificationId
                    )?.Name,
                    e.Email,
                ]
                    .filter(v => !!v)
                    .join(' | '),
                JobSpecificationId: e.JobSpecificationId,
                PersonTypeId: null as number | null,
            }));
            const mappedPersons = (persons ?? []).map(p => ({
                Id: p.Id,
                EntityType: 'Person' as const,
                optionLabel: [
                    p.DisplayName,
                    pTypes.find(
                        pt => pt.Id === p.PersonTypeId
                    )?.Name,
                    p.Email,
                    p.Organisation,
                ]
                    .filter(v => !!v)
                    .join(' | '),
                JobSpecificationId: null as number | null,
                PersonTypeId: p.PersonTypeId,
            }));

            const combined = [...mappedEmployees, ...mappedPersons];

            return combined.filter(e => {
                const jobSpecMatch = !jobSpecIds.length || (e.EntityType === 'Employee' && jobSpecIds.includes(e.JobSpecificationId));
                const roleMatch = !roleIds.length || (e.EntityType === 'Person' && roleIds.includes(e.PersonTypeId));
                if (jobSpecIds.length && roleIds.length) return jobSpecMatch || roleMatch;
                if (jobSpecIds.length) return e.EntityType === 'Employee' && jobSpecMatch;
                if (roleIds.length) return e.EntityType === 'Person' && roleMatch;
                return true;
            });
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );



    protected employeeOptions$ = combineLatest([
        this.employeesWithUserId$,
        this.singleEmployeeFilterValues$,
        this.store.select(getJobSpecification)
    ]).pipe(
        map(([employees, filterValues, jobSpecs]) => {
            const jobSpecIds = filterValues[FilterTypes.JobSpecificationIds]?.map(v => v.id) ?? [];
            const mappedEmployees = (employees ?? []).map(e => ({
                Id: e.Id,
                EntityType: 'Employee' as const,
                optionLabel: [
                    e.DisplayName,
                    jobSpecs.find(
                        js => js.Id === e.JobSpecificationId
                    )?.Name,
                    e.Email,
                ]
                    .filter(v => !!v)
                    .join(' | '),
                JobSpecificationId: e.JobSpecificationId,
                PersonTypeId: null as number | null,
            }));


            return mappedEmployees.filter(e => {
                const jobSpecMatch = !jobSpecIds.length || (e.EntityType === 'Employee' && jobSpecIds.includes(e.JobSpecificationId));
                if (jobSpecIds.length) return e.EntityType === 'Employee' && jobSpecMatch;
                return true;
            });
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );

    protected personOptions$ = combineLatest([
        this.store.select(getPersons),
        this.personFilterValues$,
        this.store.select(getPersonTypes)
    ]).pipe(
        map(([persons, filterValues, pTypes]) => {
            const roleIds = filterValues[FilterTypes.Roles]?.map(v => v.id) ?? [];


            const mappedPersons = (persons ?? []).map(p => ({
                Id: p.Id,
                EntityType: 'Person' as const,
                optionLabel: [
                    p.DisplayName,
                    pTypes.find(
                        pt => pt.Id === p.PersonTypeId
                    )?.Name,
                    p.Email,
                    p.Organisation,
                ]
                    .filter(v => !!v)
                    .join(' | '),
                JobSpecificationId: null as number | null,
                PersonTypeId: p.PersonTypeId,
            }));


            return mappedPersons.filter(e => {
                const roleMatch = !roleIds.length || (e.EntityType === 'Person' && roleIds.includes(e.PersonTypeId));
                if (roleIds.length) return  roleMatch;
                return true;
            });
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    protected planedBySearchFunction = (searchQuery: string, option: SelectSearchOption) =>
        (option.optionLabel as string)?.toLowerCase().includes(searchQuery) ?? false;


    parentCommissionOptionsSorted$: Observable<Array<IParentCommissionSelectOption&{ isSearchResult?: boolean}>>;
    parentCommissionOptionsFilterResultCount$ = new BehaviorSubject<number>(0);
    protected planedby = new FormControl<EmployeePerson | null>(null);
    protected agent = new FormControl<EmployeePerson | null>(null);
    private defaultWizardSteps: CommissionWizardSteps[] = [CommissionWizardSteps.Stammdaten,
        CommissionWizardSteps.Adresse,
        CommissionWizardSteps.Terminierung,
        CommissionWizardSteps.Kapazitaet,
        CommissionWizardSteps.Ressourcen,
        CommissionWizardSteps.Fristen,
        CommissionWizardSteps.Planungsdaten,
        CommissionWizardSteps.Mitarbeiter,
        CommissionWizardSteps.AllgDaten]

    protected addressFrom: 'parent-commission' | 'customer' = 'customer';
    public IsBauAuftrag$: Observable<boolean>;
    public Commission$ = new BehaviorSubject<CommissionEntity | null>(null);
    public CommissionId$ = new BehaviorSubject<number | null>(null);
    public CommissionPath = CommissionMeta.Path;
    public Headline$: Observable<string>;
    protected parentCommission$ = this.Commission$.pipe(switchMap(c => c?.ParentId ? this.store.select(getCommissionById({id: c.ParentId})) : of(null)))
    public commentView: ViewStyleConfig = {
        expanded: false,
        order: 1,
        headline: 'Kommentare',
        type: '',
    };

    personFilterSettings$: Observable<FilterOption[]> = combineLatest([this.store.select(getPersonTypes)]).pipe(
        map(([personTypes]) => {
            return [
                {
                    Name: FilterTypes.Roles,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Rolle',
                    Icon: 'address-book' as IconProp,
                    Values: personTypes.map((type) => ({
                        label: type.Name,
                        id: type.Id,
                    })),
                },
            ];
        }),
    );

    singleEmployeeFilterSettings$: Observable<FilterOption[]> = combineLatest([this.store.select(getJobSpecification)]).pipe(
        map(([jobs]) => {
            return [
                {
                    Name: FilterTypes.JobSpecificationIds,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Jobbezeichnung',
                    Icon: 'id-card' as IconProp,
                    Values: jobs.map((str) => ({
                        label: str.Name,
                        id: str.Id,
                    })),
                }
            ];
        }),
    );

    employeeFilterSettings$: Observable<FilterOption[]> = combineLatest([this.store.select(getJobSpecification), this.store.select(getPersonTypes)]).pipe(
        map(([jobs, personTypes]) => {
            return [
                {
                    Name: FilterTypes.JobSpecificationIds,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Jobbezeichnung',
                    Icon: 'id-card' as IconProp,
                    Values: jobs.map((str) => ({
                        label: str.Name,
                        id: str.Id,
                    })),
                },
                {
                    Name: FilterTypes.Roles,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Rolle',
                    Icon: 'address-book' as IconProp,
                    Values: personTypes.map((type) => ({
                        label: type.Name,
                        id: type.Id,
                    })),
                },
            ];
        }),
    );
    employeeFilterCount$ = this.employeeFilterValues$.pipe(
        map((filter) => {
            let count = 0;
            if (filter[FilterTypes.JobSpecificationIds]?.length > 0) count++;
            if (filter[FilterTypes.Roles]?.length > 0) count++;
            return count || undefined;
        })
    );

    employeeFilterCountAgent$ = this.employeeFilterValues$.pipe(
        map((filter) => {
            let count = 0;
            if (filter[FilterTypes.JobSpecificationIds]?.length > 0) count++;
            if (filter[FilterTypes.Roles]?.length > 0) count++;
            return count || undefined;
        })
    );

    employeeFilterCountManager$ = this.employeeFilterValues$.pipe(
        map((filter) => {
            let count = 0;
            if (filter[FilterTypes.JobSpecificationIds]?.length > 0) count++;
            if (filter[FilterTypes.Roles]?.length > 0) count++;
            return count || undefined;
        })
    );

    singleEmployeeFilterCount$ = this.singleEmployeeFilterValues$.pipe(
        map((filter) => {
            let count = 0;
            if (filter[FilterTypes.JobSpecificationIds]?.length > 0) count++;
            return count || undefined;
        })
    );
    personFilterCount$ = this.personFilterValues$.pipe(
        map((filter) => {
            let count = 0;
            if (filter[FilterTypes.Roles]?.length > 0) count++;
            return count || undefined;
        })
    );

    protected addressFromValues$: Observable<{label: string, value: CommissionWizardComponent['addressFrom']}[]> = combineLatest([
        this.cls.getSingle$('CustomerSupplier'),
        this.parentCommission$.pipe(filter(isNotNullOrUndefined)),
        this.store.select(getCommissionTypeDictionary),
    ]).pipe(
        map(([customer, parentCommission, commissionTypes]) => {
            return [
                {
                    label: commissionTypes[parentCommission.CommissionTypeId].Name,
                    value: 'parent-commission',
                },
                {
                    label: customer,
                    value: 'customer',
                }
            ]
        })
    );


    protected userToCommissionFromCommission$ = this.Commission$.pipe(
        switchMap((c) =>
            c ? this.store.select(getUserToCommissions).pipe(map((u2cs) => u2cs.filter((u2c) => u2c.CommissionId === c.Id))) : of([]),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected IamAssignee$ = combineLatest([this.userToCommissionFromCommission$, this.store.select(getUser)]).pipe(map(([u2cs, user]) => u2cs.some((u2c) => u2c.UserId === user.Id && u2c.Assignee)));
    protected CommentFileUploadParams$: Observable<FileUploadParams>;
    public Steps$: Observable<{ customSave?: () => void; name: string; customTemplate?: TemplateRef<any>; data?: Observable<IDetailListTemplateData>; controlsInvalid: () => boolean; }[]>;
    protected subscriptions: Subscription[] = [];
    public EmployeeResources: {
        entity?: EmployeeResourceScheduleEntity;
        availableActivities$: Observable<ActivityEntity[]>;
        form: FormGroup<{
            from: FormControl<Moment>;
            to: FormControl<Moment>;
            amount: FormControl<number>;
            jobSpecification: FormControl<JobSpecificationEntity>;
            color: FormControl<Color>;
            name: FormControl<string>;
            activities: FormControl<ActivityEntity[]>;
        }>;
    }[] = [];
    public JobSpecifications$ = this.store.select(getJobSpecification);
    private employeeResScheduleFromCommission$ = this.Commission$.pipe(
        switchMap((c) =>
            c
                ? this.store.select(getEmployeeResourceSchedulesFetched).pipe(
                      tap((fetched) => {
                          if (!fetched) {
                              this.employeeResourceScheduleResolver.resolve();
                          }
                      }),
                      filter((res) => res),
                      switchMap(() => this.store.select(getEmployeeResourceSchedules)),
                      map((ers) => ers.filter((e) => e.CommissionId === c.Id)),
                  )
                : of([]),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    Activities$ = this.store.select(getActivityFetched).pipe(
        tap((fetched) => {
            if (!fetched) {
                this.activityRes.resolve();
            }
        }),
        filter((fetched) => fetched),
        switchMap(() => this.store.select(getActivities)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private sharepointToken$ = getMySharepointToken(this.store);

    constructor(
        protected store: Store<State>,
        protected dialog: MatDialog,
        protected appDialog: AppDialogService,
        protected fb: UntypedFormBuilder,
        public BS: BreakpointObserverService,
        private employeeResourceScheduleResolver: EmployeeResourceScheduleResolver,
        private departmentResolver: DepartmentResolver,
        private activityRes: ActivityResolver,
        private actions$: Actions,
        protected cls: CustomLabelService,
        @Optional() @Inject(MAT_DIALOG_DATA) public DialogData: CommissionWizardComponentDialogData,
        protected ls: LoadingService,
        @Optional() private dialogRef: MatDialogRef<CommissionWizardComponent>,
        private customizationDataService: CustomizationDataService,
        private officeResolver: OfficeResolver,
        private customerDataService: CustomerDataService,
        private userToCommissionResolver: UserToCommissionResolver,
        private commissionWizardDialogService: CommissionWizardDialogService,
        private activatedRoute: ActivatedRoute,
        ) {
        this.sharepointToken$.pipe((take(1))).subscribe((token) => {
            if ((!token)) {
                this.subscriptions.push(
                    this.store.select(getOAuthTokenFetched).pipe(
                        distinctUntilChanged(),
                        tap((fetched) => {
                            if (!fetched) {
                                this.store.dispatch(OAuthTokenActionTypes.Load());
                            }
                        }),
                    ).subscribe(),
                );
            }
        })

        if (this.dialogRef) {
            this.subscriptions.push(this.dialogRef.backdropClick().subscribe(() => {
                this.closeDialog();
            }));
        }
        if (DialogData) {
            this.CommissionId = DialogData.commissionId;
            this.DetailListTemplateEntrys = DialogData.detailListTemplateEntries;
            this.StatusBackofficeForm = DialogData.statusBackofficeForm;
            this.PartnerOfficeForm = DialogData.partnerOfficeForm;
            if (DialogData.wizardSteps) {
                this.WizardSteps = DialogData.wizardSteps;
            }
        }
    }
    private newPersonDefaultValues: PersonModalComponentDialogData['newPersonDefaultValues'];
    onAddPersonButtonClick(formControl: FormControl<EmployeePerson>) {
        this.dialog.open<PersonModalComponent, PersonModalComponentDialogData>(PersonModalComponent, {
                ...PersonModalComponent.DefaultConfig,
                data: {
                    newPersonDefaultValues: this.newPersonDefaultValues,

                },
                // panelClass: 'custom-dialog-class-without-padding-margin-top-1-75',
            })
            .afterClosed()
            .subscribe(async newPerson => {
                if (newPerson) {
                    formControl.setValue({
                        EntityType: "Person",
                        Id: newPerson.Person.Id
                    });
                }
            });

    }

    ngOnInit(): void {
        if (this.CommissionId === null) {
            this.subscriptions.push(
                this.store.select(getEmployeesSortedByNameStartWithMe).pipe(
                    filter(isNotNullOrUndefined),
                    first(),
                ).subscribe((employees) => {
                    const ownEmployee = employees?.[0];

                    if (ownEmployee?.DepartmentId) {
                        this.DetailListTemplateEntrys.DepartmentId?.formControl?.setValue({
                            Id: ownEmployee.DepartmentId,
                        });
                    }
                }),
                this.customizationDataService.getFeatures$().pipe().subscribe((features) => {
                    if(features?.includes('kaplCommissionStatus4Dialog')){
                        this.subscriptions.push(
                            this.StatusBackofficeForm.valueChanges
                                .pipe(
                                    startWith(this.DetailListTemplateEntrys.StatusBackofficeId.formControl.value),
                                    pairwise(),
                                    distinctUntilChanged(([, a], [, b]) => a?.Id === b?.Id),
                                    withLatestFrom(
                                        this.store.select(getStatusFromBackoffice),
                                        this.store.select(getEntityRole),
                                        this.userToCommissionFromCommission$,
                                    ),
                                )
                                .subscribe(([[previousStatus, newStatus], allBos, entityRoles, u2c]) => {
                                    const selected = allBos.find((b) => b.Id === newStatus?.Id);
                                    if (selected?.Name !== StatusFromBackofficeNames.KaplStep4) {
                                        return;
                                    }

                                    const BauleiterRole = entityRoles.find((r) => r.Slug === 'Bauleiter');
                                    const u2cBauleiter = u2c.find((u) => u.RoleId === BauleiterRole?.Id);

                                    if (this.DetailListTemplateEntrys.Kostenstellenart.value && this.DetailListTemplateEntrys.DepartmentId.value && u2cBauleiter) {
                                        return; // already complete, nothing to ask for
                                    }

                                    this.dialog
                                        .open<KaplStatus4DialogComponent, MissingCommissionValuesDialogData, MissingCommissionValuesResult>(
                                            KaplStatus4DialogComponent,
                                            {
                                                data: {
                                                    CommissionIds: [this.CommissionId],
                                                    BauleiterRoleId: BauleiterRole?.Id,
                                                },
                                            },
                                        )
                                        .afterClosed()
                                        .subscribe((result) => {
                                            const values = result?.[this.CommissionId];
                                            if (!values) {
                                                const previousStatusFind = allBos.find((b) => b.Id === previousStatus?.Id);
                                                this.DetailListTemplateEntrys.StatusBackofficeId.formControl.setValue({ Id: previousStatusFind.Id, Name: previousStatusFind.Name });
                                                return;
                                            }

                                            if(!u2cBauleiter) {
                                                this.store.dispatch(
                                                    UserToCommissionActionTypes.Create({
                                                        Payload: {
                                                            userId: values.BauleiterUserId,
                                                            commissionId: this.CommissionId,
                                                            roleId: BauleiterRole.Id,
                                                        },
                                                    }),
                                                );
                                            }
                                            this.DetailListTemplateEntrys.Kostenstellenart.formControl.setValue(values.Kostenstellenart);
                                            this.DetailListTemplateEntrys.DepartmentId.formControl.setValue(values.DepartmentId);
                                        });
                                }),
                        )
                    }
                }),
            );

        }else{
            this.subscriptions.push(
                this.customizationDataService.getFeatures$().pipe().subscribe((features) => {
                    if(features?.includes('kaplCommissionStatus4Dialog')){
                        this.subscriptions.push(
                            this.StatusBackofficeForm.valueChanges
                                .pipe(
                                    startWith(this.DetailListTemplateEntrys.StatusBackofficeId.formControl.value),
                                    pairwise(),
                                    distinctUntilChanged(([, a], [, b]) => a?.Id === b?.Id),
                                    withLatestFrom(
                                        this.store.select(getStatusFromBackoffice),
                                        this.store.select(getEntityRole),
                                        this.userToCommissionFromCommission$,
                                    ),
                                )
                                .subscribe(([[previousStatus, newStatus], allBos, entityRoles, u2c]) => {
                                    const selected = allBos.find((b) => b.Id === newStatus?.Id);
                                    if (selected?.Name !== StatusFromBackofficeNames.KaplStep4) {
                                        return;
                                    }

                                    const BauleiterRole = entityRoles.find((r) => r.Slug === 'Bauleiter');
                                    const u2cBauleiter = u2c.find((u) => u.RoleId === BauleiterRole?.Id);

                                    if (this.DetailListTemplateEntrys.Kostenstellenart.value && this.DetailListTemplateEntrys.DepartmentId.value && u2cBauleiter) {
                                        return; // already complete, nothing to ask for
                                    }

                                    this.dialog
                                        .open<KaplStatus4DialogComponent, MissingCommissionValuesDialogData, MissingCommissionValuesResult>(
                                            KaplStatus4DialogComponent,
                                            {
                                                data: {
                                                    CommissionIds: [this.CommissionId],
                                                    BauleiterRoleId: BauleiterRole?.Id,
                                                },
                                            },
                                        )
                                        .afterClosed()
                                        .subscribe((result) => {
                                            const values = result?.[this.CommissionId];
                                            if (!values) {
                                                const previousStatusFind = allBos.find((b) => b.Id === previousStatus?.Id);
                                                this.DetailListTemplateEntrys.StatusBackofficeId.formControl.setValue({ Id: previousStatusFind.Id, Name: previousStatusFind.Name });
                                                return;
                                            }

                                            if(!u2cBauleiter) {
                                                this.store.dispatch(
                                                    UserToCommissionActionTypes.Create({
                                                        Payload: {
                                                            userId: values.BauleiterUserId,
                                                            commissionId: this.CommissionId,
                                                            roleId: BauleiterRole.Id,
                                                        },
                                                    }),
                                                );
                                            }
                                            this.DetailListTemplateEntrys.Kostenstellenart.formControl.setValue(values.Kostenstellenart);
                                            this.DetailListTemplateEntrys.DepartmentId.formControl.setValue(values.DepartmentId);
                                        });
                                }),
                        )
                    }
                }),
            );
            this.CommentFileUploadParams$ = this.Commission$.pipe(
                map(c => c?.Id),
                distinctUntilChanged(),
                map(
                    (commissionId) =>
                        commissionId &&
                        new Map<keyof fileUploadParamsObj, string>([
                            ['hidden', 'true'],
                            ['auto_set_folder', 'true'],
                            ['sub_folder_type', getFolderTypeString(FolderTypes.image_root)],
                            ['commission_id', JSON.stringify([commissionId])],
                        ]),
                ),
            );
        }
        this.Headline$ = merge(
            this.DetailListTemplateEntrys.CommissionType.formControl.valueChanges as Observable<SelectSearchData>,
            this.Commission$.pipe(switchMap((c) => c?.CommissionTypeId ? this.store.select(getCommissionTypeById({ id: c.CommissionTypeId })) : of(null))),
        ).pipe(
            withLatestFrom(this.cls.getSingle$('Commission')),
            map(([ct, commissionLabel]) => (ct?.Name || commissionLabel) + ' anlegen'),
        );
        this.subscriptions.push(
            this.CommissionId$.pipe(
                filter(isNotNullOrUndefined),
                switchMap((id) => this.store.select(getCommissionById({ id }))),
            ).subscribe((commission) => {
                this.Commission$.next(commission);
            }),
            combineLatest([
                this.employeeResScheduleFromCommission$,
                this.Activities$.pipe(
                    first(),
                    switchMap(() => this.store.select(getActivityDictionary)),
                    first(),
                ),
                this.store.select(getJobSpecificationDictionary),
            ]).subscribe(([ers, activities, jobs]) => {
                this.EmployeeResources = ers.map((e) => {
                    const selectedActivities = e.ActivityIds?.map((id) => activities[id]) || [];
                    return {
                        entity: e,
                        availableActivities$: this.store.select(getActivities).pipe(map((activities) => activities.filter((a) => !a.DeletedAt || selectedActivities.some((b) => b.Id === a.Id)))),
                        form: new FormGroup({
                            from: new FormControl<Moment>(moment(e.StartDate)),
                            to: new FormControl<Moment>(moment(e.EndDate)),
                            amount: new FormControl<number>(e.Amount),
                            jobSpecification: new FormControl<JobSpecificationEntity>(e.JobSpecificationId && jobs[e.JobSpecificationId]),
                            color: new FormControl<Color>(e.Color && new Color(e.Color.Red, e.Color.Green, e.Color.Blue)),
                            name: new FormControl<string>(e.Name),
                            activities: new FormControl<ActivityEntity[]>(e.ActivityIds?.map((id) => activities[id])),
                        }),
                    };
                });
                this.EmployeeResources.forEach(({ form }) => this.onEmployeeResourceJobSelectionChange(form));
                if (this.EmployeeResources.length === 0) {
                    this.AddResourceEmployee();
                }
            }),
        );
        const customerControl = this.DetailListTemplateEntrys.Customer?.formControl as FormControl<SelectSearchData | null>;
        if (customerControl) {
            this.subscriptions.push(
                customerControl.valueChanges
                    .pipe(
                        // nur wenn der Kunde durch den Nutzer ausgewählt wurde, nicht beim Laden des Auftrags
                        filter(() => customerControl.dirty && this.addressFrom === 'customer'),
                        map((customer) => customer?.Id),
                        distinctUntilChanged(),
                        filter(isNotNullOrUndefined),
                    )
                    .subscribe(() => this.setAddressFromCustomer()),
            );
        }
        const parentCommissionControl = this.DetailListTemplateEntrys.ParentCommission?.formControl as FormControl<{ Id: number } | null>;
        if (parentCommissionControl) {
            this.subscriptions.push(
                parentCommissionControl.valueChanges
                    .pipe(
                        // nur wenn der Über-Auftrag durch den Nutzer ausgewählt wurde, nicht beim Laden des Auftrags
                        filter(() => parentCommissionControl.dirty),
                        map((parentCommission) => parentCommission?.Id),
                        distinctUntilChanged(),
                        filter(isNotNullOrUndefined),
                        switchMap((id) =>
                            this.store.select(getCommissionById({ id })).pipe(
                                filter(isNotNullOrUndefined),
                                first(),
                            ),
                        ),
                    )
                    .subscribe((parentCommission) => this.setValuesFromParentCommissionIfEmpty(parentCommission)),
            );
            if (this.IsNewCommission && parentCommissionControl.value?.Id) {
                firstValueFrom(
                    this.store.select(getCommissionById({ id: parentCommissionControl.value.Id })).pipe(
                        filter(isNotNullOrUndefined),
                        first(),
                    ),
                ).then((parentCommission) => this.setValuesFromParentCommissionIfEmpty(parentCommission));
            }
        }
        this.IsBauAuftrag$ = combineLatest([
            merge(this.Commission$.pipe(map((commission) => ({ Id: commission?.CommissionTypeId }))), this.DetailListTemplateEntrys.CommissionType.formControl.valueChanges),
            this.store.select(getCommissionTypes),
        ]).pipe(
            map(([commissionType, commissionTypes]) => commissionType?.Id && commissionType.Id === commissionTypes.find((cT) => cT?.Name === CommissionTypeNameEnum.Bauprojekt)?.Id),
            distinctUntilChanged(),
        );
    }


    overrideDetailListTemplateEntrys(v: ICommissionDetailListTemplateEntrys): ICommissionDetailListTemplateEntrys {
        return {...v, ParentCommission: { ...v.ParentCommission, options: {specialInput: {customTemplate: this.parentCommissionSearchTemplate}} }}
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    protected isCurrentStepValid$: Observable<boolean>;

    protected isCommissionTypeValid$: Observable<boolean>;

    ngAfterViewInit(): void {
        // reset to add templates if missing
        this.DetailListTemplateEntrys = this._detailListTemplateEntrys;
        this.Steps$ = combineLatest([
            combineLatest([
                this.Commission$.pipe(
                    tap(commission => console.log(commission)),
                    switchMap((c) => (c?.CommissionTypeId ? this.store.select(getCommissionTypeById({ id: c.CommissionTypeId })).pipe(map((ct) => ct.AdditionalData?.WizardSteps)) : of(null))),
                ),
                this.store.select(getPartner),
            ]).pipe(
                map(([ctSteps, partner]) => {
                    const steps = partner.Settings?.WizardSteps?.length
                        ? partner.Settings.WizardSteps
                        : ctSteps;
                    return steps || this.WizardSteps || this.defaultWizardSteps;
                }),
                distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
            ),
            this.store.select(getPartner),
            this.store.select(getEmployeesSortedByNameStartWithMe),
            this.cls.getSingle$('CustomerSupplier'),
            this.cls.getSingle$('Customer'),
            combineLatest([
                this.Commission$,
                this.store.select(getCommissionTypeDictionary),
            ]).pipe(
                map(([comm, commissionTypeDictionary]) => comm?.CommissionTypeId ? commissionTypeDictionary[comm.CommissionTypeId]?.AdditionalData?.CanHaveChildCommissions : null),
                distinctUntilChanged(),
            )
        ]).pipe(
            map(([steps, partner, employees, customerLabel, customerLableWithOutSupplier,  commissionTypeCanHaveChildren]) => {
                const isKaplStepEnabled = partner.Settings?.WizardSteps?.includes(CommissionWizardSteps.StammdatenKapl);
                if (isKaplStepEnabled) {
                    this.DetailListTemplateEntrys.Description?.formControl?.addValidators(Validators.required);
                   // this.DetailListTemplateEntrys.Person?.formControl?.addValidators(Validators.required);
                    this.DetailListTemplateEntrys.Customer?.formControl?.addValidators(Validators.required);
                    this.DetailListTemplateEntrys.DepartmentId?.formControl?.addValidators(Validators.required);
                    this.DetailListTemplateEntrys.ProjectAdmin.formControl?.setValue({
                        Name: '',
                        Id: employees[0].Id,
                    });
                }
                const Steps: { customSave?: () => void; name: string; customTemplate?: TemplateRef<any>; data?: Observable<IDetailListTemplateData>; controlsInvalid: () => boolean }[] = [
                    steps.includes(CommissionWizardSteps.Stammdaten)
                        ? {
                              name: partner.PartnerTypeId === PartnerTypeEnum.TSB && commissionTypeCanHaveChildren ? 'Name Einsatzort': partner.PartnerTypeId === PartnerTypeEnum.TSB ? customerLabel : 'Stammdaten',
                              data: merge(this.Commission$.pipe(distinctUntilChanged((a, b) => a.CommissionTypeId === b.CommissionTypeId)), this.DetailListTemplateEntrys.CommissionType.formControl.valueChanges).pipe(
                                  map(() => ({
                                      Properties: [
                                          this.DetailListTemplateEntrys.Customer,
                                          // this.DetailListTemplateEntrys.CommissionType,
                                          // this.DetailListTemplateEntrys.InterneNummer,
                                          // this.DetailListTemplateEntrys.InterneNummerAuto,
                                          // this.DetailListTemplateEntrys.CommissonNumber,
                                          // this.DetailListTemplateEntrys.CommissonNumberAuto,
                                          this.DetailListTemplateEntrys.Description,
                                          this.DetailListTemplateEntrys.ProjectInfo,
                                      ].filter(isNotNullOrUndefined),
                                  })),
                              ),
                            customTemplate: this.stepOneTemplate,
                              // controls: this.fb.array([this.DetailListTemplateEntrys.CommissionType.formControl]),
                            controlsInvalid: () => false,
                          }
                        : undefined,
                    steps.includes(CommissionWizardSteps.Adresse)
                        ? {
                              name: partner.PartnerTypeId === PartnerTypeEnum.TSB ? 'Einsatzort' : 'Adresse',
                              customTemplate: this.addressTemplate,
                              data: of({
                                  Properties: [
                                      /*this.DetailListTemplateEntrys.CustomerLocation,*/
                                      /*this.DetailListTemplateEntrys.Location*/
                                  ].filter(isNotNullOrUndefined),
                              }),
                            controlsInvalid: () => false,
                          }
                        : undefined,
                    steps.includes(CommissionWizardSteps.Terminierung)
                        ? {
                    // Projekteingang, Geplantes Startdatum, geplantes Enddatum, Angebotsabgabe, Verhandlung am
                              name: 'Terminierung',
                              data: of({
                                  Properties: [
                                      this.DetailListTemplateEntrys.Auftragseingang,
                                      this.DetailListTemplateEntrys.PlanedStartDate,
                                      this.DetailListTemplateEntrys.PlanedEndDate,
                                      this.DetailListTemplateEntrys.OfferSubmissionDate,
                                      this.DetailListTemplateEntrys.NegotiationAt,
                                  ].filter(isNotNullOrUndefined),
                              }),
                            controlsInvalid: () => false,
                          }
                        : undefined,
                    steps.includes(CommissionWizardSteps.Kapazitaet)
                        ? {
                              name: 'Kapazität',
                              customSave: () => this.SaveResourceEmployees(),
                              customTemplate: this.capacityTemplate,
                              controlsInvalid: () => false,
                          }
                        : undefined,
                    steps.includes(CommissionWizardSteps.Ressourcen)
                        ? {
                              name: 'Geräte',
                              customSave: () => this.SelectResourceComponent.Save(),
                              customTemplate: this.resourceTemplate,
                              controlsInvalid: () => false,
                          }
                        : undefined,
                    steps.includes(CommissionWizardSteps.StammdatenKapl)
                        ? {
                            name: 'Stammdaten',
                            // data: merge(this.Commission$.pipe(distinctUntilChanged((a, b) => a.CommissionTypeId === b.CommissionTypeId)), this.DetailListTemplateEntrys.CommissionType.formControl.valueChanges).pipe(
                            //     map(() => ({
                            //         Properties: [
                            //             this.DetailListTemplateEntrys.Description,
                            //             this.DetailListTemplateEntrys.ProjectInfo,
                            //             this.DetailListTemplateEntrys.Person,
                            //         ].filter(isNotNullOrUndefined),
                            //     })),
                            // ),
                            customSave: () => this.submitStepOneTemplateKapl(),
                            customTemplate: this.stepOneTemplateKapl,
                            // controls: this.fb.array([this.DetailListTemplateEntrys.CommissionType.formControl]),
                            controlsInvalid: () => this.DetailListTemplateEntrys.Description.formControl.invalid,
                        }
                        : undefined,
                    steps.includes(CommissionWizardSteps.PlanungsdatenKapl)
                        ? {
                            name: 'Planungsdaten',

                            customSave: () => this.submitStepTwoTemplateKapl(),
                            customTemplate: this.stepTwoTemplateKapl,
                            controlsInvalid: () => false,
                        }
                        : undefined,
                ].filter(isNotNullOrUndefined);
                const stepFristen = {
                    name: 'Fristen',
                    data: of({
                        Properties: [this.DetailListTemplateEntrys.AbgabeterminAG, this.DetailListTemplateEntrys.AbgabeterminQM, this.DetailListTemplateEntrys.LetzteFrist].filter(isNotNullOrUndefined),
                    }),
                    controlsInvalid: () => false,
                };
                const _stepPlanningProperites = [
                    this.DetailListTemplateEntrys.PlanedWorkingHours,
                    this.DetailListTemplateEntrys.CompleteBusinessVolume,
                    this.DetailListTemplateEntrys.CostsCompleteBusinessVolume
                ].filter(isNotNullOrUndefined);
                const stepPlanning = {
                    name: 'Planungsdaten',
                    data: of({
                        Properties: _stepPlanningProperites,
                    }),
                    controlsInvalid: () => false,
                };
                if (steps.includes(CommissionWizardSteps.Fristen) && partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser) {
                    Steps.push(stepFristen);
                }
                if (steps.includes(CommissionWizardSteps.Planungsdaten) && _stepPlanningProperites.length > 0 && partner.PartnerSpecificationTypeId === PartnerSpecificationType.Construction) {
                    Steps.push(stepPlanning);
                }
                if (steps.includes(CommissionWizardSteps.Mitarbeiter)) {
                    const stepMitarbeiter = {
                        name: 'Mitarbeiter',
                        customTemplate: this.selectTeamTemplate,
                        controlsInvalid: () => false,
                    };
                    Steps.push(stepMitarbeiter);
                }
                if (steps.includes(CommissionWizardSteps.AllgDaten)) {
                    const stepAlgDaten = {
                        name: 'Allg. Daten',
                        data: this.IsBauAuftrag$.pipe(
                            map((isBauauftrag) => {
                                return {
                                    Properties: [
                                        this.DetailListTemplateEntrys.Versicherungssumme,
                                        partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser ? this.DetailListTemplateEntrys.Schadensdatum : null,
                                        partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser ? this.DetailListTemplateEntrys.Schadennummer : null,
                                        partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser ? this.DetailListTemplateEntrys.Versicherungsnummer : null,
                                        this.DetailListTemplateEntrys.AutomaticAccountsReceivableLedger,
                                        this.DetailListTemplateEntrys.AutomaticAccountsReceivableLedgerByClockIns,
                                        isBauauftrag ? this.DetailListTemplateEntrys.VorarbeiterBonus : null,
                                        isBauauftrag ? this.DetailListTemplateEntrys.NachlassZulage : null,
                                    ].filter(isNotNullOrUndefined),
                                };
                            }),
                        ),
                        controlsInvalid: () => false,
                    };
                    Steps.push(stepAlgDaten);
                }
                return Steps;
            }),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
        this.subscriptions.push(
            this.Commission$.pipe(
                filter(isNotNullOrUndefined),
                distinctUntilChanged((a, b) => a.Id === b.Id),
            ).subscribe((c) => {
                if (c.ParentId) {
                    firstValueFrom(this.store.select(getPartner)).then(partner => {
                        if (
                            partner.PartnerTypeId === PartnerTypeEnum.TSB
                        ) {
                            if (
                                !this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup.value.Street &&
                                !this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup.value.PostalCode &&
                                !this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup.value.City &&
                                !this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup.value.Country
                            ) {
                                this.onAddressFromChange('parent-commission')
                            } else {
                                // only set for frontend without setting address forms
                                this.addressFrom = 'parent-commission';
                            }
                        }
                    })
                }
                // ugly fix um die richtige seite aus zu wählen, den selectedIndex vom stepper setzen reicht nicht, da die vorherigen steps dann nicht completed sind und deshalb nicht weiter geklickt werden kann
                // der stepper ist zwar auch ohne den timeout schon da scheinbar wird der noch einmal ausgetauscht
                setTimeout(() => {
                    for (let i = 0; i < c.AdditionalData.wizardPage - 1; i++) {
                        this.Stepper.next();
                    }
                }, 100);
            }),
        );

        const commissionTypeControl =
            this.DetailListTemplateEntrys.CommissionType?.formControl;

        this.isCommissionTypeValid$ = merge(
            of(null),
            commissionTypeControl?.statusChanges ?? of(null),
            commissionTypeControl?.valueChanges ?? of(null)
        ).pipe(
            map(() => !!commissionTypeControl?.valid && !!commissionTypeControl?.value?.Id),
            shareReplay({ bufferSize: 1, refCount: true }),
        );

        //All StepsValid
//         const allControls = [
//             this.DetailListTemplateEntrys.Location?.options?.specialInput?.location?.formGroup as FormGroup,
//             ...Object.values(this.DetailListTemplateEntrys)
//                 .map((entry: any) => entry?.formControl)
//         ].filter(Boolean);
//
//         this.isCurrentStepValid$ = merge(
//             of(null),
//             ...allControls.map(c => c.statusChanges)
//         ).pipe(
//             map(() => {
//
//                 // allControls.forEach((c, index) => {
//                 //     console.log('Control', index, {
//                 //         status: c.status,
//                 //         valid: c.valid,
//                 //         invalid: c.invalid,
//                 //         errors: c.errors,
//                 //         value: c.value,
//                 //     });
//                 // });
//
//                 const result = allControls.every(c => c.valid);
//
// //                console.log('STEP VALID:', result);
//
//                 return result;
//             }),
//             shareReplay({ bufferSize: 1, refCount: true }),
//         );
    }

    public RemoveResourceEmployee(index: number) {
        this.EmployeeResources.splice(index, 1);
    }
    public AddResourceEmployee() {
        this.Commission$.pipe(filter(isNotNullOrUndefined), first()).subscribe((c) => {
            this.EmployeeResources.push({
                availableActivities$: this.store.select(getActivitiesActive),
                form: new FormGroup({
                    from: new FormControl(c.StartDate ? moment(c.StartDate) : c.PlannedStartDate ? moment(c.PlannedStartDate) : moment()),
                    to: new FormControl(c.EndDate ? moment(c.EndDate) : c.PlannedEndDate ? moment(c.PlannedEndDate) : moment()),
                    amount: new FormControl(null),
                    name: new FormControl(null),
                    jobSpecification: new FormControl(null),
                    color: new FormControl(null),
                    activities: new FormControl(null),
                }),
            });
        });
    }
    public SaveResourceEmployees() {
        this.employeeResScheduleFromCommission$.pipe(first()).subscribe((ers) => {
            const add = this.EmployeeResources.filter((e) => !e.entity && e.form.valid && e.form.value.amount);
            const change = this.EmployeeResources.filter((e) => e.entity && e.form.dirty);
            const remove = ers.filter((er) => !this.EmployeeResources.some((e) => e.entity?.Id === er.Id));

            add.forEach((e) => {
                const StartDate = e.form.value.from.toDate();
                StartDate.setHours(0, 0, 0, 0);
                const EndDate = e.form.value.to.toDate();
                EndDate.setHours(23, 59, 59, 999);

                this.store.dispatch(
                    EmployeeResourceScheduleActionTypes.Create({
                        Payload: {
                            amount: e.form.value.amount,
                            commissionId: this.CommissionId,
                            endDate: FrontendDate(EndDate),
                            startDate: FrontendDate(StartDate),
                            color: e.form.value.color ? { red: e.form.value.color.r, green: e.form.value.color.g, blue: e.form.value.color.b, opacity: e.form.value.color.a } : null,
                            name: e.form.value.name,
                            jobSpecificationId: e.form.value.jobSpecification?.Id || null,
                            activityIds: e.form.value.activities?.map((a) => a.Id),
                        },
                    }),
                );
            });
            change.forEach((e) => {
                const StartDate = e.form.value.from.toDate();
                StartDate.setHours(0, 0, 0, 0);
                const EndDate = e.form.value.to.toDate();
                EndDate.setHours(23, 59, 59, 999);
                this.store.dispatch(
                    EmployeeResourceScheduleActionTypes.Change({
                        Payload: {
                            amount: e.form.value.amount,
                            id: e.entity.Id,
                            endDate: FrontendDate(EndDate),
                            startDate: FrontendDate(StartDate),
                            color: e.form.value.color ? { red: e.form.value.color.r, green: e.form.value.color.g, blue: e.form.value.color.b, opacity: e.form.value.color.a } : null,
                            name: e.form.value.name,
                            jobSpecificationId: e.form.value.jobSpecification?.Id || null,
                            activityIds: e.form.value.activities?.map((a) => a.Id),
                        },
                    }),
                );
            });
            remove.forEach((e) => this.store.dispatch(EmployeeResourceScheduleActionTypes.Delete({ Payload: e.Id })));
        });
    }
    NextAndDetailsClick(steps) {
        if (this.ls.isLoading) {
            return;
        }
        if (this.Stepper.selectedIndex === steps.length - 1) {
            firstValueFrom(combineLatest([
                this.store.select(getPartner),
                this.store.select(getStatusFromBackoffice),
            ])).then(([partner, states]) => {
                if (partner.PartnerTypeId === PartnerTypeEnum.TSB) {
                    const state = states.find(s => s.Name === StatusFromBackofficeNames.ZurPlanung);
                    console.log('setStateToPlanung')
                    if (state) {
                        this.StatusBackofficeForm.setValue({
                            Name: '',
                            Id: state.Id,
                        }, {emitEvent: false})
                    }
                }
                this.NextClick(steps, true, ['/', this.CommissionPath, this.CommissionId]);
            })
        } else {
            this.NextClick(steps, true, ['/', this.CommissionPath, this.CommissionId]);
        }
    }
    openNewCommissionWizard(){
        firstValueFrom(
            this.store.select(getPartner).pipe(
                switchMap((partner) =>
                    (partner.PartnerTypeId === PartnerTypeEnum.TSB
                        ? this.store.select(getCommissionTypes).pipe(
                            map((cts) => ({
                                partner,
                                commissionType: cts.find((ct) => ct.AdditionalData?.IsDefault),
                            })),
                        )
                        : of({
                            partner,
                            commissionType: null,
                        }))
                ),
            ),
        ).then(({ partner, commissionType }) => {

            if (!partner.Settings?.WizardSteps) {
                this.dialog.open<NewCommissionDialogComponent, NewCommissionDialogComponentDialogData>(NewCommissionDialogComponent, {
                    ...NewCommissionDialogComponent.DefaultConfig,
                    data: {
                        CreateCommissionPayload: {
                            auftragseingangDurchAuftraggeber: new Date().toDateString(),
                        },
                        NavigateRelativeTo: this.activatedRoute,
                        ForceCommissionTypeId: commissionType?.Id,
                    },
                });
            }else{
                this.commissionWizardDialogService.OpenDialog(null, partner.Settings.WizardSteps);
            }
        });
    }
    NextClick(steps, closeAllDialogs = false, routerLink: any[] = null) {
        if (this.ls.isLoading) {
            return;
        }
        if (steps[this.Stepper.selectedIndex].customSave) {
           const skipExecution =  steps[this.Stepper.selectedIndex].customSave();

           if(skipExecution === true) {
                return;
           }
        }
            if (this.Stepper.selectedIndex !== steps.length - 1) {
                this.Save.emit({ wizardPage: this.Stepper.selectedIndex + 2, routerLink });
                this.Stepper.next();
            } else {
                this.Save.emit({ wizardPage: null, routerLink });
                if (closeAllDialogs) {
                    // wait for someone's reaction on Save.emit()
                    setTimeout(() => this.dialog.closeAll(), 1);
                }
            }
            if(this.kaplParentIdSet$.value){
                setTimeout(() => this.dialogRef.close(), 1);
            }
    }

    protected readonly getErrorMessage = getErrorMessage;
    activityToLabel = (a: ActivityEntity) => a.Name;

    addNewActivity(name: string, activities: FormControl<ActivityEntity[]>) {
        activities.disable();
        firstValueFrom(this.actions$.pipe(ofType(ActivityActions.updateOne, BaseActionTypes.ErrorAction))).then((a) => {
            activities.enable();
            if (a.type === ActivityActions.updateOne.type) {
                activities.setValue([...activities.value, a.Payload]);
            }
        });
        this.store.dispatch(ActivityActions.add({ Payload: { name } }));
    }

    onEmployeeResourceJobSelectionChange(
        formGroup: FormGroup<{
            from: FormControl<moment.Moment>;
            to: FormControl<moment.Moment>;
            amount: FormControl<number>;
            jobSpecification: FormControl<JobSpecificationEntity>;
            color: FormControl<Color>;
            name: FormControl<string>;
            activities: FormControl<ActivityEntity[]>;
        }>,
    ) {
        if (formGroup.controls.jobSpecification.value) {
            formGroup.controls.color.setValue(null);
            formGroup.controls.color.disable();
            formGroup.controls.name.setValue(null);
            formGroup.controls.name.disable();
        } else {
            formGroup.controls.color.enable();
            formGroup.controls.name.enable();
        }
    }

    HasRequiredField = hasRequiredField;
    SearchJobSpecification = (search: string, option: JobSpecificationEntity) => option.Name.toLowerCase().includes(search.toLowerCase());

    DeleteActivity(Option: ActivityEntity) {
        this.appDialog
            .OpenConfirmationDialog({
                heading: 'Aktivität löschen ?',
                paragraph: 'Möchten Sie die Tätigkeit ' + Option.Name + ' wirklich löschen?',
                styleDelete: true,
            })
            .subscribe(([del, s]) => {
                if (del) {
                    this.store.dispatch(ActivityActions.delete({ Payload: { id: Option.Id } }));
                }
            });
    }

    onAddressFromChange($event: typeof this.addressFrom) {
        this.addressFrom = $event;
        switch (this.addressFrom) {
            case 'customer':
                this.setAddressFromCustomer();
                break;
            case 'parent-commission':
                this.setAddressFromParentCommission();
                break;
        }
    }

    /**
     * Übernimmt die Adresse des ausgewählten Kunden nur, wenn noch keine Adresse eingetragen ist.
     * Das Land zählt dabei nicht als eingetragene Adresse, da es mit dem Standardland des Partners vorbelegt wird.
     */
    private setAddressFromCustomerIfEmpty() {
        const location = this.getLocationControl()?.value;
        if (!location || location.Street || location.PostalCode || location.City) {
            return;
        }
        this.setAddressFromCustomer();
    }
    private getLocationControl(): FormControl<Address> | null {
        return (this.DetailListTemplateEntrys.Location?.options?.specialInput?.location?.formGroup as FormControl<Address>) || null;
    }

    /**
     * Übernimmt Kunde, Adresse und Termine aus dem ausgewählten Über-Auftrag, aber nur in Felder, die noch leer sind.
     */
    private  setValuesFromParentCommissionIfEmpty(parentCommission: CommissionEntity)
    {
        this.setCustomerFromParentCommission(parentCommission);
        this.setDatesFromParentCommission(parentCommission);
        this.setAddressFieldsFromParentCommission(parentCommission);

        this.customizationDataService.getFeatures$().pipe(
            take(1),
            filter((features) => features?.includes('kaplSetParentCommissionValues')),
            switchMap(() =>
                parentCommission.CommissionTypeId
                    ? this.store.select(getCommissionTypeById({ id: parentCommission.CommissionTypeId })).pipe(take(1))
                    : of(null),
            ),
        ).subscribe((commissionType) => {
            this.kaplParentIdSet$.next(true);
            if (parentCommission.Description) {
                this.DetailListTemplateEntrys?.Description?.formControl.setValue(
                    parentCommission.Description,
                );
            }

            if (parentCommission.FreeTextField1) {
                this.DetailListTemplateEntrys?.ProjectInfo?.formControl.setValue(
                    parentCommission.FreeTextField1,
                );
            }

            if (commissionType) {
                this.DetailListTemplateEntrys?.CommissionType?.formControl.setValue({
                    Id: commissionType.Id,
                    Name: commissionType.Name,
                });
            }
        });
    }


    private setAddressFieldsFromParentCommission(parentCommission: CommissionEntity) {
        const locationControl = this.getLocationControl();
        const location = locationControl?.value;

        if (!parentCommission.Street && !parentCommission.PostalCode && !parentCommission.City) {
            return;
        }
        locationControl.setValue({
            Street: parentCommission.Street || null,
            PostalCode: parentCommission.PostalCode || null,
            City: parentCommission.City || null,
            // Land nur überschreiben, wenn der Über-Auftrag eines hat, sonst z.B. das Standardland des Partners behalten
            Country: parentCommission.Country || location?.Country || null,
        });
        const travelZoneControl = this.DetailListTemplateEntrys.TravelZoneId?.formControl;
        if (travelZoneControl && !travelZoneControl.value) {
            travelZoneControl.setValue(parentCommission.TravelZoneId);
        }
    }

    private setCustomerFromParentCommission(parentCommission: CommissionEntity) {
        const customerControl = this.DetailListTemplateEntrys.Customer?.formControl;
        if (!customerControl || !parentCommission.CustomerId) {
            return;
        }
        firstValueFrom(this.customerDataService.GetSingleCustomer$(parentCommission.CustomerId)).then((customer) => {
            if (customer && !customerControl.value) {
                customerControl.setValue(customer);
            }
        });
    }

    /**
     * Baubeginn geplant und Angebotsdatum für die zweite Wizard-Seite vorbelegen
     */
    private setDatesFromParentCommission(parentCommission: CommissionEntity) {
        const plannedStartDateControl = this.DetailListTemplateEntrys.PlanedStartDate?.formControl;
        if (plannedStartDateControl && !plannedStartDateControl.value && parentCommission.PlannedStartDate) {
            plannedStartDateControl.setValue(moment(parentCommission.PlannedStartDate));
        }
        const offerSubmissionDateEntry = this.DetailListTemplateEntrys.OfferSubmissionDate;
        const offerSubmissionDateControl = offerSubmissionDateEntry?.formControl;
        if (offerSubmissionDateControl && !offerSubmissionDateControl.value && parentCommission.OfferSubmissionDate) {
            offerSubmissionDateControl.setValue(moment(parentCommission.OfferSubmissionDate));
            const dateOptions = offerSubmissionDateEntry.options?.specialInput?.date;
            const timeControl = typeof dateOptions === 'object' ? dateOptions.timeFormControl : null;
            if (timeControl) {
                timeControl.setValue(moment(parentCommission.OfferSubmissionDate).format('HH:mm'));
            }
        }
    }
    setAddressFromCustomer() {
        const locationControl = this.getLocationControl();
        if (!locationControl) {
            return;
        }
        const customerId = this.DetailListTemplateEntrys.Customer?.formControl.value?.Id;
        if (customerId) {
            firstValueFrom(getFetched$(this.store, getOfficesFetched, getOfficeByCustomerId({ id: customerId }), this.officeResolver)).then((office) => {
                locationControl.setValue({
                    Street: office?.Street || null,
                    PostalCode: office?.PostalCode || null,
                    City: office?.City || null,
                    // Land nur überschreiben, wenn der Kunde eines hat, sonst z.B. das Standardland des Partners behalten
                    Country: office?.Country || locationControl.value?.Country || null,
                });
            });
        } else {
            locationControl.setValue({
                Street: null,
                PostalCode: null,
                City: null,
                Country: null,
            });
        }
    }
    setAddressFromParentCommission() {
        firstValueFrom(this.parentCommission$).then(commission => {
            if (commission) {
                this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup.setValue({
                    Street: commission.Street,
                    PostalCode: commission.PostalCode,
                    City: commission.City,
                    Country: commission.Country,
                })
                this.DetailListTemplateEntrys.TravelZoneId.formControl.setValue(commission.TravelZoneId);
            }
            else {
                this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup.setValue({
                    Street: null,
                    PostalCode: null,
                    City: null,
                    Country: null,
                })
                this.DetailListTemplateEntrys.TravelZoneId.formControl.setValue(null);
            }
        })
    }


    protected readonly CommissionEntity = CommissionEntity;
    protected compareById = (a: {Id: number}, b: {Id: number}) => a?.Id === b?.Id;
    protected readonly CommentEntityTypeEnum = CommentEntityTypeEnum;


    private departmentsForSubCommissionsControl = new FormControl<DepartmentEntity[]>([]);
    protected departmentsForSubCommissions$: Observable<IDetailListTemplateDataProperty<DepartmentEntity>> = combineLatest([
        getFetched$(this.store,getDepartmentFetched, getDepartmentsActive, this.departmentResolver),
        getFetched$(this.store,getPartnerOfficesFetched, getPartnerOfficeDictionary),
        this.cls.getSingle$('Commission'),
        this.cls.getMultiple$('Department'),
    ]).pipe(map(([departments, partnerOffices, commissionLabel, departmentsLabel]) => {
        console.log('## form', this.departmentsForSubCommissionsControl);
        return {
            key: commissionLabel+' für '+departmentsLabel + ' anlegen',
            formControl: this.departmentsForSubCommissionsControl,
            options: {
                showHint: 'Für die ausgewählten '+departmentsLabel+' wird ein Teil'+(commissionLabel.toLowerCase())+' angelegt',
                specialInput: {
                    chipAutocomplete: {
                        MapFn: (option: DepartmentEntity) => option.optionLabel + (option.PartnerOfficeId ? ' ('+partnerOffices[option.PartnerOfficeId].Name+')' : ''),
                        Options: departments,
                    }
                }
            }
        }
    }))

    submitStepOneTemplateKapl(){
        if (!this.CommissionId) {
            this.ls.startLoading('add-commission-from-wizard');
            firstValueFrom(this.store.select(getStatusFromBackoffice))
                .then(async (status) => {
                    const statusBackofficeId = status.find((s) => s.IsDefault)?.Id;
                    const department = await firstValueFrom(this.store.select(getDepartmentById({id: this.DetailListTemplateEntrys.DepartmentId?.formControl?.value?.Id})))
                    const additionalData = this.kaplParentIdSet$.value ? JSON.stringify({ wizardPage: null }) : JSON.stringify({ wizardPage: 2 })
                    this.store.dispatch(
                        CommissionActionTypes.AddCommission({
                            Payload: {
                                commissionTypeId: this.DetailListTemplateEntrys.CommissionType?.formControl?.value?.Id || null,
                                description: this.DetailListTemplateEntrys.Description?.formControl?.value,
                                parentId: this.DetailListTemplateEntrys.ParentCommission?.formControl?.value?.Id || null,
                                auftragsnummer: this.DetailListTemplateEntrys.CommissonNumber?.formControl?.value,
                                automaticAuftragsnummer: true,
                                // interneNummer: this.DetailListTemplateEntrys.InterneNummer?.formControl?.value,
                                partnerOfficeId: department?.PartnerOfficeId,
                                automaticInterneNummer: true,
                                additionalData: additionalData,
                                statusBackofficeId: statusBackofficeId,
                                customerId: this.DetailListTemplateEntrys.Customer?.formControl?.value?.Id || null,
                                personId: this.DetailListTemplateEntrys.Person?.formControl?.value?.Id || null,
                                departmentId: this.DetailListTemplateEntrys.DepartmentId?.formControl?.value?.Id || null,
                                freeTextField1: this.DetailListTemplateEntrys.ProjectInfo?.formControl?.value,
                                street: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.Street,
                                city: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.City,
                                postalCode: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.PostalCode,
                                country: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.Country,
                            },
                        }),
                    );
                    this.DetailListTemplateEntrys.StatusBackofficeId.formControl.setValue({
                        Name: '',
                        Id: statusBackofficeId,
                    });

                    return firstValueFrom(this.actions$.pipe(ofType(CommissionActionTypes.UpdateOne, BaseActionTypes.ErrorAction)));
                })
                .then(async (action) => {
                    this.ls.endLoading('add-commission-from-wizard');
                    if (action.type === CommissionActionTypes.UpdateOne.type) {
                        this.PartnerOfficeForm.setValue({
                            Name: '',
                            Id: action.Payload.PartnerOfficeId,
                        });
                        this.DetailListTemplateEntrys.CommissonNumberAuto?.formControl.setValue(false);
                        this.CommissionId = (action as any).Payload.Id;

                        if (this.DetailListTemplateEntrys.ProjectAdmin.formControl.value && this.kaplParentIdSet$.value ){
                            console.log("TEST", this.DetailListTemplateEntrys.ProjectAdmin.formControl.value)

                            await firstValueFrom(this.store.select(getEntityRole)).then(async entityRoles => {

                                const AdminRole = entityRoles.find(r => r.Slug === 'Projektadmin');

                                    const user = await firstValueFrom(this.store.select(getUserByEmployeeId({ id: this.DetailListTemplateEntrys.ProjectAdmin.formControl?.value?.Id})));

                                const userToCommissions = await firstValueFrom(
                                    this.store.select(
                                        getUserToCommissionByCommissionId({
                                            commissionId: this.CommissionId,
                                        }),
                                    ).pipe(
                                        filter((userToCommissions) => !!userToCommissions?.length),
                                        take(1),
                                    ),
                                );
                                    const existinguserToCommission = userToCommissions.find(u => u.UserId === user.Id && u.RoleId === AdminRole.Id);
                                console.log("TEST2", userToCommissions, AdminRole)
                                    if(!existinguserToCommission) {
                                        this.store.dispatch(UserToCommissionActionTypes.Create({
                                                Payload: {
                                                    userId: user.Id,
                                                    commissionId: this.CommissionId,
                                                    roleId: AdminRole.Id,
                                                    assignee: false,
                                                },
                                            }),
                                        );
                                    }



                            });

                        }

                    }
                });
            return;
        } else {
            this.Save.emit({wizardPage: this.Stepper.selectedIndex + 2, skipValidation: true, routerLink: null});
            this.Stepper.next();
            return true;
        }
    }

    async submitStepTwoTemplateKapl() {
        if (this.departmentsForSubCommissionsControl.value.length > 0) {
            const status = await firstValueFrom(this.store.select(getStatusFromBackoffice));
            const statusBackofficeId = status.find((s) => s.IsDefault)?.Id;
            this.departmentsForSubCommissionsControl.value.forEach(department => {
                this.store.dispatch(CommissionActionTypes.AddCommission({Payload: {
                        commissionTypeId: this.DetailListTemplateEntrys.CommissionType?.formControl?.value?.Id || null,
                        description: this.DetailListTemplateEntrys.Description?.formControl?.value,
                        parentId: this.CommissionId,
                        // auftragsnummer: this.DetailListTemplateEntrys.CommissonNumber?.formControl?.value,
                        // automaticAuftragsnummer: this.DetailListTemplateEntrys.CommissonNumberAuto?.formControl?.value,
                        // interneNummer: this.DetailListTemplateEntrys.InterneNummer?.formControl?.value,
                        automaticInterneNummer: true, // todo Alex fragen ob das gewollt ist
                        automaticAuftragsnummer: true, // todo Alex fragen ob das gewollt ist
                        additionalData: JSON.stringify({ wizardPage: null }),
                        statusBackofficeId: statusBackofficeId,
                        customerId: this.DetailListTemplateEntrys.Customer?.formControl?.value?.Id || null,
                        personId: this.DetailListTemplateEntrys.Person?.formControl?.value?.Id || null,
                        departmentId: department?.Id,
                        partnerOfficeId: department?.PartnerOfficeId,
                        freeTextField1: this.DetailListTemplateEntrys.ProjectInfo?.formControl?.value,
                        street: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.Street,
                        city: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.City,
                        postalCode: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.PostalCode,
                        country: this.DetailListTemplateEntrys.Location.options.specialInput.location.formGroup?.value?.Country,
                        // todo ggf felder die auf seite 2 bearbeitet wurden auch hier setzen
                    }}))
            });
            this.departmentsForSubCommissionsControl.reset([]);
        }

        if(this.DetailListTemplateEntrys.ProjectAdmin.formControl.value || this.agent.value || this.planedby.value || this.DetailListTemplateEntrys.ProjectManager.formControl.value ){
            await firstValueFrom(this.store.select(getEntityRole)).then(async entityRoles => {
                const PlanerRole = entityRoles.find(r => r.Slug === 'Planer');
                const AdminRole = entityRoles.find(r => r.Slug === 'Projektadmin');
                const AgentRole = entityRoles.find(r => r.Slug === 'Auschreiber');
                const ManagerRole = entityRoles.find(r => r.Slug === 'Projektverantwortlicher');

                if(this.DetailListTemplateEntrys.ProjectAdmin.formControl?.value?.Id){
                    const user = await firstValueFrom(this.store.select(getUserByEmployeeId({ id: this.DetailListTemplateEntrys.ProjectAdmin.formControl?.value?.Id})));
                    const userToCommissions = await firstValueFrom(this.store.select(getUserToCommissionByCommissionId({ commissionId: this.CommissionId })));
                    const existinguserToCommission = userToCommissions.find(u => u.UserId === user.Id && u.RoleId === AdminRole.Id);
                    if(!existinguserToCommission) {
                        this.store.dispatch(UserToCommissionActionTypes.Create({
                                Payload: {
                                    userId: user.Id,
                                    commissionId: this.CommissionId,
                                    roleId: AdminRole.Id,
                                    assignee: false,
                                },
                            }),
                        );
                    }
                }
                if(this.DetailListTemplateEntrys.ProjectManager.formControl?.value?.Id){
                    const user = await firstValueFrom(this.store.select(getUserByEmployeeId({ id: this.DetailListTemplateEntrys.ProjectManager.formControl?.value?.Id})));
                    const userToCommissions = await firstValueFrom(this.store.select(getUserToCommissionByCommissionId({ commissionId: this.CommissionId })));
                    const existinguserToCommission = userToCommissions.find(u => u.UserId === user.Id && u.RoleId === AdminRole.Id);
                    if(!existinguserToCommission) {
                        this.store.dispatch(UserToCommissionActionTypes.Create({
                                Payload: {
                                    userId: user.Id,
                                    commissionId: this.CommissionId,
                                    roleId: ManagerRole.Id,
                                    assignee: false,
                                },
                            }),
                        );
                    }
                }
                if(this.agent.value) {
                    if(this.agent.value.EntityType === 'Employee'){
                    const user = await firstValueFrom(this.store.select(getUserByEmployeeId({ id: this.agent.value.Id })));
                    const userToCommissions = await firstValueFrom(this.store.select(getUserToCommissionByCommissionId({ commissionId: this.CommissionId })));
                    const existinguserToCommission = userToCommissions.find(u => u.UserId === user.Id && u.RoleId === AgentRole.Id);
                    if (!existinguserToCommission) {
                        this.store.dispatch(UserToCommissionActionTypes.Create({
                                Payload: {
                                    userId: user.Id,
                                    commissionId: this.CommissionId,
                                    roleId: AgentRole.Id,
                                    assignee: false,
                                },
                            }),
                        );
                    }
                }//Employee
                        //ToDo Kontakt Rollen anpassen
                   else {
                        const person2Entities = await firstValueFrom(this.store.select(
                            getPerson2EntityByCommissionId({ commissionId: this.CommissionId })
                        ));
                        const existingPerson2Entity = person2Entities.find(p => p.PersonId === this.agent.value.Id && p.ComplaintTypeId === 3);
                        if (!existingPerson2Entity) {
                            this.store.dispatch(
                                Person2EntityActionTypes.AddPerson2Entity({
                                    Payload: {
                                        personId: this.agent.value.Id,
                                        entityId: this.CommissionId,
                                        entityType: Person2EntityEntityTypeEnum.Commission,
                                        complaintTypeId: 3,
                                    },
                                }),
                            );
                        }
                    } //Person
                }

                if(this.planedby.value) {
                    if(this.planedby.value.EntityType === 'Employee'){
                        const user = await firstValueFrom(this.store.select(getUserByEmployeeId({ id: this.planedby.value.Id })));
                        const userToCommissions = await firstValueFrom(this.store.select(getUserToCommissionByCommissionId({ commissionId: this.CommissionId })));
                        const existinguserToCommission = userToCommissions.find(u => u.UserId === user.Id && u.RoleId === PlanerRole.Id);
                        if (!existinguserToCommission) {
                            this.store.dispatch(UserToCommissionActionTypes.Create({
                                    Payload: {
                                        userId: user.Id,
                                        commissionId: this.CommissionId,
                                        roleId: PlanerRole.Id,
                                        assignee: false,
                                    },
                                }),
                            );
                        }
                    }//Employee
                    //ToDo Kontakt Rollen anpassen
                    else {
                        const person2Entities = await firstValueFrom(this.store.select(
                            getPerson2EntityByCommissionId({ commissionId: this.CommissionId })
                        ));
                        const existingPerson2Entity = person2Entities.find(p => p.PersonId === this.planedby.value.Id && p.ComplaintTypeId === 3);
                        if (!existingPerson2Entity) {
                            this.store.dispatch(
                                Person2EntityActionTypes.AddPerson2Entity({
                                    Payload: {
                                        personId: this.planedby.value.Id,
                                        entityId: this.CommissionId,
                                        entityType: Person2EntityEntityTypeEnum.Commission,
                                        complaintTypeId: 3,
                                    },
                                }),
                            );
                        }
                    } //Person
                }
            });

        }
        this.Save.emit({wizardPage: null, routerLink: null, skipValidation: true,});
        setTimeout(() => this.dialog.closeAll(), 1);
    }
    closeDialog() {
        if (this.dialogRef) {
            if (this.canDeactivate() || confirm(PENDING_CHANGES_DEFAULT_MESSAGE)) {
                this.dialogRef.close();
            }
        }
    }
    private getAllControls(): AbstractControl[] {
        return [
            ...Object.values(this.DetailListTemplateEntrys ?? {})
                .map((entry: any) => entry?.formControl),
            this.DetailListTemplateEntrys?.Location?.options?.specialInput?.location?.formGroup,
            this.StatusBackofficeForm,
            this.PartnerOfficeForm,
            this.planedby,
            this.agent,
            this.departmentsForSubCommissionsControl,
            ...this.EmployeeResources.map(e => e.form),
        ].filter(Boolean);
    }

    canDeactivate(): boolean {
        return this.getAllControls().every(c => !c.dirty);
    }
}
